var _clipPath, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFootprints(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0.0 0.0 166.45669291338584 100.0",
    fill: "none",
    stroke: "none",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "p.0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0l166.4567 0l0 100.0l-166.4567 0l0 -100.0z",
    clipRule: "nonzero"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p.0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m0 0l166.4567 0l0 100.0l-166.4567 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "p.1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0.0 7.697887975937713 -7.697887975937713 0.0 0.0 0.0)",
    spreadMethod: "pad",
    x1: 0.33103487150252603,
    y1: -11.44504707838149,
    x2: 0.33100700617992346,
    y2: -3.7471591024942126
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#915e29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#703e08"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#p.1)",
    d: "m32.606853 21.885391c0.7260895 3.0176582 -0.15239716 6.840399 1.8335762 8.253479c1.9859734 1.4130821 6.2635155 -0.42368507 10.082268 0.22500801c3.8187485 0.6486931 6.7199135 4.125143 12.830235 3.6671505c6.110321 -0.45799637 18.713955 -3.16926 23.831684 -6.415119c5.117737 -3.2458572 7.2569046 -9.164682 6.87471 -13.060031c-0.38219452 -3.8953495 -3.5538483 -8.440189 -9.167877 -10.312063c-5.6140213 -1.8718739 -16.381687 -2.2173645 -24.516281 -0.91918087c-8.134594 1.2981834 -20.663223 5.6148243 -24.291275 8.708283c-3.6280518 3.0934591 1.7968712 6.834813 2.5229607 9.852473z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#915e29",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m32.606853 21.885391c0.7260895 3.0176582 -0.15239716 6.840399 1.8335762 8.253479c1.9859734 1.4130821 6.2635155 -0.42368507 10.082268 0.22500801c3.8187485 0.6486931 6.7199135 4.125143 12.830235 3.6671505c6.110321 -0.45799637 18.713955 -3.16926 23.831684 -6.415119c5.117737 -3.2458572 7.2569046 -9.164682 6.87471 -13.060031c-0.38219452 -3.8953495 -3.5538483 -8.440189 -9.167877 -10.312063c-5.6140213 -1.8718739 -16.381687 -2.2173645 -24.516281 -0.91918087c-8.134594 1.2981834 -20.663223 5.6148243 -24.291275 8.708283c-3.6280518 3.0934591 1.7968712 6.834813 2.5229607 9.852473z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "p.2",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0.0 5.187110509183072 -5.187110509183072 0.0 0.0 0.0)",
    spreadMethod: "pad",
    x1: 2.694452486262919,
    y1: -5.788393035609598,
    x2: 2.6944337089621055,
    y2: -0.6012825264605118
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#915e29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#703e08"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#p.2)",
    d: "m27.563694 22.575125c0.87848854 2.7112656 3.70545 5.6132298 1.8335743 8.018898c-1.8718739 2.4056683 -9.092871 5.918825 -13.064817 6.4151173c-3.9719477 0.49629593 -8.628494 -1.3372803 -10.766867 -3.437355c-2.1383727 -2.100071 -3.017659 -6.2994213 -2.0633702 -9.163084c0.95428896 -2.8636646 4.351748 -6.33852 7.789102 -8.018898c3.437355 -1.6803789 10.12296 -3.0942574 12.835025 -2.0633707c2.7120628 1.0308876 2.5588646 5.537429 3.4373531 8.2486925z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#915e29",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m27.563694 22.575125c0.87848854 2.7112656 3.70545 5.6132298 1.8335743 8.018898c-1.8718739 2.4056683 -9.092871 5.918825 -13.064817 6.4151173c-3.9719477 0.49629593 -8.628494 -1.3372803 -10.766867 -3.437355c-2.1383727 -2.100071 -3.017659 -6.2994213 -2.0633702 -9.163084c0.95428896 -2.8636646 4.351748 -6.33852 7.789102 -8.018898c3.437355 -1.6803789 10.12296 -3.0942574 12.835025 -2.0633707c2.7120628 1.0308876 2.5588646 5.537429 3.4373531 8.2486925z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "p.3",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0.0 -7.69788764296914 -7.69788764296914 0.0 0.0 0.0)",
    spreadMethod: "pad",
    x1: -12.659432619392442,
    y1: -21.213404275941155,
    x2: -12.65946058876899,
    y2: -13.515516633022827
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#915e29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#703e08"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#p.3)",
    d: "m107.80257 78.11377c0.7260895 -3.0176544 -0.15239716 -6.8404007 1.83358 -8.253479c1.9859695 -1.4130783 6.2635193 0.42368317 10.082268 -0.2250061c3.8187485 -0.6486969 6.7199173 -4.125145 12.830231 -3.6671524c6.110321 0.45799255 18.713959 3.169258 23.831696 6.415123c5.1177216 3.2458572 7.256897 9.1646805 6.874695 13.060028c-0.3821869 3.8953476 -3.553833 8.440186 -9.167862 10.312065c-5.614029 1.871872 -16.381699 2.2173615 -24.516281 0.9191818c-8.134598 -1.2981873 -20.66323 -5.61483 -24.291283 -8.70829c-3.6280518 -3.0934525 1.796875 -6.8348083 2.5229568 -9.85247z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#915e29",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m107.80257 78.11377c0.7260895 -3.0176544 -0.15239716 -6.8404007 1.83358 -8.253479c1.9859695 -1.4130783 6.2635193 0.42368317 10.082268 -0.2250061c3.8187485 -0.6486969 6.7199173 -4.125145 12.830231 -3.6671524c6.110321 0.45799255 18.713959 3.169258 23.831696 6.415123c5.1177216 3.2458572 7.256897 9.1646805 6.874695 13.060028c-0.3821869 3.8953476 -3.553833 8.440186 -9.167862 10.312065c-5.614029 1.871872 -16.381699 2.2173615 -24.516281 0.9191818c-8.134598 -1.2981873 -20.66323 -5.61483 -24.291283 -8.70829c-3.6280518 -3.0934525 1.796875 -6.8348083 2.5229568 -9.85247z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "p.4",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0.0 -5.1871101385766964 -5.1871101385766964 0.0 0.0 0.0)",
    spreadMethod: "pad",
    x1: -16.583943279277715,
    y1: -20.285042432255505,
    x2: -16.58396106830081,
    y2: -15.097932293709311
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#915e29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#703e08"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#p.4)",
    d: "m102.759415 77.424034c0.87848663 -2.7112656 3.7054443 -5.613228 1.8335724 -8.018898c-1.871872 -2.4056702 -9.092873 -5.9188232 -13.064819 -6.4151154c-3.9719467 -0.49629593 -8.628494 1.3372803 -10.766869 3.437355c-2.1383743 2.1000748 -3.0176544 6.299423 -2.0633698 9.163086c0.9542923 2.8636627 4.3517456 6.338516 7.7891006 8.018898c3.437355 1.6803741 10.122963 3.0942535 12.83503 2.0633698c2.712059 -1.0308914 2.5588608 -5.53743 3.437355 -8.248695z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#915e29",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m102.759415 77.424034c0.87848663 -2.7112656 3.7054443 -5.613228 1.8335724 -8.018898c-1.871872 -2.4056702 -9.092873 -5.9188232 -13.064819 -6.4151154c-3.9719467 -0.49629593 -8.628494 1.3372803 -10.766869 3.437355c-2.1383743 2.1000748 -3.0176544 6.299423 -2.0633698 9.163086c0.9542923 2.8636627 4.3517456 6.338516 7.7891006 8.018898c3.437355 1.6803741 10.122963 3.0942535 12.83503 2.0633698c2.712059 -1.0308914 2.5588608 -5.53743 3.437355 -8.248695z",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFootprints);
export default __webpack_public_path__ + "static/media/footprints.ccfd4acd228217a1920e7879965eb079.svg";
export { ForwardRef as ReactComponent };